'use strict';

$('header').addClass('minimize');
$('main').addClass('minimize');
$('.nav-icon-pad').addClass('minimize');

$(".format-money").on("change keydown paste input", function () {
    $(this).mask('000 000 000 000 000', { reverse: true });
});

$(".format-year").on("change keydown paste input", function () {
    $(this).mask('0000');
});

$(".format-pnr").on("change keydown paste input", function () {
    $(this).mask('00000000000');
});

$(".format-regnr").on("change keydown paste input", function () {
    //$(this).mask('SS 00000');
    //console.log($(this).val())
    //$(this).mask('', {byPassKeys: [8, 9, 37, 38, 39, 40]});
    this.value = this.value.toUpperCase();
    var e = window.event || e;
    var key = e.keyCode;

    //console.log(key)
    //space pressed
    if (key == 32 || key == 189) {
        //space or dash
        e.preventDefault();
    }
});

$(".format-phone").on("change keydown paste input", function () {
    $(this).val().charAt(0) === "9" || $(this).val().charAt(0) === "4" ? $(this).mask("000 00 000") : $(this).mask("00 00 00 00");
});

$(".format-post").on("change keydown paste input", function () {
    $(this).mask('0000 SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS');
});

$('#insuranceform').on('submit', function () {
    var form = $('#insuranceform');
    form.validate();
    var isFormValid = form.valid();
    if (isFormValid) {
        btnAnimation();
        return true;
    } else {
        return false;
    }
});

function filterInspectors() {
    var e = document.getElementById("SelectedCounty");
    var county = e.options[e.selectedIndex].text;
    var allInspectors = document.getElementsByClassName('inspector');
    for (var i = 0; i < allInspectors.length; i++) {
        var countyForInspector = allInspectors[i].dataset.county;
        if (county === countyForInspector) {
            allInspectors[i].style.display = "block";
        } else {
            allInspectors[i].style.display = "none";
        }
    }
}